import { Zap, Cable, Building2, PanelTop } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const SCOPE = [
  { icon: Cable, label: "Redes elétricas residenciais" },
  { icon: Building2, label: "Redes elétricas prediais" },
  { icon: PanelTop, label: "Painel de comando" },
];

export default function Eletricos() {
  return (
    <section data-testid="hidropro-electrical-services-section" className="relative overflow-hidden bg-brand-ink py-16 md:py-24 lg:py-32">
      <div className="absolute inset-0 bg-blueprint-dark" />
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <div>
          <SectionHead index="03" label="Solução — Elétrica" title="E também cuidamos da parte elétrica." dark />
          <Reveal delay={0.2}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
              A HidroPro Serviços Técnicos também oferece serviços de instalação e manutenção elétrica residencial e
              predial, incluindo manutenção e adequação de painéis de comando.
            </p>
          </Reveal>
          <Reveal delay={0.28}>
            <ul className="mt-8 flex flex-col gap-3">
              {SCOPE.map((item) => (
                <li key={item.label} className="flex items-center gap-3 text-white/90">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-water/15 text-water">
                    <item.icon className="h-4 w-4" />
                  </span>
                  <span className="text-sm font-medium sm:text-base">{item.label}</span>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.36}>
            <div className="mt-8 inline-flex items-center gap-2.5 rounded-full border border-water/40 bg-water/10 px-4 py-2">
              <Zap className="h-4 w-4 text-water" />
              <span className="text-xs font-semibold uppercase tracking-[0.14em] text-water sm:text-sm">
                Hidráulica e elétrica no mesmo atendimento
              </span>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.15}>
          <figure className="tick-corner relative overflow-hidden rounded-2xl border border-white/10" data-testid="hidropro-electrical-photo">
            <img
              src="https://images.unsplash.com/photo-1660330589693-99889d60181e?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Eletricista realizando manutenção em painel de comando"
              loading="lazy"
              className="h-[300px] w-full object-cover sm:h-[420px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/80 via-transparent to-transparent" />
            <figcaption className="absolute bottom-5 left-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/85">
              Painel de comando · Redes residenciais e prediais
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </section>
  );
}
